import React from "react";
import TileLoader from '../common/tileLoader';
import DetailsCostInsurance from './detailsCostInsurance';
import DetailsCostSelfPay from './detailsCostSelfPay';
import Spinner from '../common/spinner';
import { logUI } from "../../api/andyliticsApi";


const DetailsCostTile = props => {
    const { benefitDetails, isSelfPay, pricingCOVIDMessage } = props;
    const bd = benefitDetails[0];//benefitDetails &&     
    const tileName = "YOUR OUT-OF-POCKET ESTIMATE IS";
    try {
        if (Object.keys(bd).length !== 0) {
            return <>
                {isSelfPay ? <DetailsCostSelfPay benefitDetails={bd} tileName={tileName} pricingCOVIDMessage={pricingCOVIDMessage} />
                    : < DetailsCostInsurance benefitDetails={bd} tileName={tileName} pricingCOVIDMessage={pricingCOVIDMessage} />}
            </>;
        } else {
            return <div className="row"><Spinner />
                <div className="col-12"><TileLoader tilename={tileName} /></div>
            </div>;
        }
    } catch (ex) {
        logUI("MBHWeb.UI.Estimates.detailsCostTile", new Date(), `estimateDetails/${props.csnId}`, props, 'ERROR', ex.message);
        return <React.Fragment>{ex}</React.Fragment>;
    }
}


export default DetailsCostTile;

